// stripe.js
import { loadStripe } from '@stripe/stripe-js';

export const STRIPE_PUBLISHABLE_KEY = 'pk_test_51PwuJtLr6wIV1gENR9T6YNBUaNZ3scvVTuPLxaYaPJci0tqrGoQAEyoV85prj2hygMY7kbUGKppuOJ2fkjal66O100KL5zFDVD';

export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);